import AiQuotaApi from '../api/ai_quota';

export default {
  namespaced: true,
  state: {
    quotaStatus: null,
  },
  getters: {
    hasRoleplayQuota: (state) => state.quotaStatus?.actions?.roleplay?.allowed,
    hasImproveSpeechQuota: (state) => state.quotaStatus?.actions?.improve_speech?.allowed,
    hasRefineScriptQuota: (state) => state.quotaStatus?.actions?.refine_script?.allowed,
    hasGenerateScriptQuota: (state) => state.quotaStatus?.actions?.generate_script?.allowed,
    generateScriptQuota: (state) => state.quotaStatus?.actions?.generate_script ?? { allowed: true, used: 0, limit: null },
    roleplayQuota: (state) => state.quotaStatus?.actions?.roleplay ?? { allowed: true, used: 0, limit: null },
    improveSpeechQuota: (state) => state.quotaStatus?.actions?.improve_speech ?? { allowed: true, used: 0, limit: null },
    refineScriptQuota: (state) => state.quotaStatus?.actions?.refine_script ?? { allowed: true, used: 0, limit: null },
    quotaNextReset: (state) => state.quotaStatus?.nextReset ?? null,
  },
  actions: {
    fetchQuotaStatus({ commit, rootGetters }) {
      const programId = rootGetters['programs/selectedProgram']?._id;
      return new Promise((resolve, reject) => {
        AiQuotaApi.getStatus(programId)
          .then((data) => {
            commit('SET_QUOTA_STATUS', data);
            resolve(data);
          })
          .catch(reject);
      });
    },
  },
  mutations: {
    SET_QUOTA_STATUS(state, status) {
      state.quotaStatus = status;
    },
  },
};
